export default __webpack_public_path__ + "70f1fc23f86abc2b0ffa6cdabc9f5414.png";